// extracted by mini-css-extract-plugin
export default {"noticeWrapper":"ReceiptCopyDialog--noticeWrapper--48a25f"};